import sharedUiBR from './sharedUi.br';
import sharedUiES from './sharedUi.es';
import sharedUiMX from './sharedUi.mx';
import sharedUiCL from './sharedUi.cl';
import sharedUiCO from './sharedUi.co';

const sharedUi = {
  BR: sharedUiBR,
  ES: sharedUiES,
  MX: sharedUiMX,
  CL: sharedUiCL,
  CO: sharedUiCO,
};

export default sharedUi;
